'use client';

// Global variable to store the session expired handler
let sessionExpiredHandler: (() => void) | null = null;

export const setSessionExpiredHandler = (handler: (() => void) | null) => {
  sessionExpiredHandler = handler;
};

export const triggerSessionExpired = () => {
  if (sessionExpiredHandler) {
    sessionExpiredHandler();
  } else {
    // Fallback: redirect to search results if no handler is set
    window.location.href = '/search-results/all-year?defaultFt=1';
  }
};
